import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { BottomRightSlot, HudSlots, TopLeftSlot, TopRightSlot, } from '../shared/HudSlots';
import { OverlayToggle } from '../shared/OverlayToggle';
import { PluginButtonTray as PrestyledPluginButtonTray } from '../shared/PluginButtonTray';
import { PluginComponentContainer } from '../shared/PluginComponentContainer';
import { PluginOverlayContainer } from '../shared/PluginOverlayContainer';
export function BroadcasterViewHud({ fullscreenButton, visible, onToggleMetrics, showMetrics, }) {
    const [showPluginOverlay, setShowPluginOverlay] = useState(true);
    return (_jsxs(_Fragment, { children: [_jsxs(Hud, { "$visible": visible, children: [_jsx(TopLeftSlot, {}), _jsx(TopRightSlot, { children: _jsx(PluginButtonTray, { slotId: "buttonstray", hidden: !visible }) }), _jsxs(BottomRightSlot, { children: [_jsx(OverlayToggle, { checked: showPluginOverlay, onChange: setShowPluginOverlay }), onToggleMetrics && (_jsx(MetricsToggle, { onClick: onToggleMetrics, title: showMetrics ? 'Hide Metrics' : 'Show Metrics', children: "\uD83D\uDCCA" })), fullscreenButton] })] }), showPluginOverlay && _jsx(PluginOverlayContainer, { slotId: "overlay" }), _jsx(PluginComponentContainer, { slotId: "components" })] }));
}
const PluginButtonTray = styled(PrestyledPluginButtonTray) `
    position: static;
    top: auto;
    left: auto;
`;
const Hud = styled(HudSlots) `
    z-index: 10;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
    pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;
const MetricsToggle = styled.button `
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: white;
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;
    padding: 6px 8px;
    transition: background-color 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.9);
    }

    &:active {
        transform: scale(0.95);
    }
`;
